export enum ERROR_TYPES {
  notFound = 'NOT_FOUND',
  termsNotAccepted = 'TERMS_NOT_ACCEPTED',
  subcontractorUnauthenticated = 'SUBCONTRACTOR_UNAUTHENTICATED',
  suggestionSentToInvalidSubcontractor = 'SUGGESTION_SENT_TO_INVALID_SUBCONTRACTOR',
  unauthorized = 'UNAUTHORIZED',
  docuSignEnvelopeDoesNotExistError = 'DOCU_SIGN_ENVELOPE_DOES_NOT_EXIST_ERROR',
  domainIsUsedByAnotherCompany = 'DOMAIN_IS_USED_BY_ANOTHER_COMPANY',
  cannotRevokeInvitationForUnexpectedStatus = 'CANNOT_REVOKE_INVITATION_FOR_UNEXPECTED_STATUS',
}
